// ============================================================
//  CONTENU CENTRALISÉ — Portfolio Andrew Picornell
//  Modifiez ce fichier pour personnaliser tout le site.
//  Rempli à partir des CV fournis. [crochets] = à compléter.
// ============================================================

export const profil = {
  nom: "Andrew",
  prenomNom: "Andrew PICORNELL",
  initiales: "AP",
  titre: "Management, Conseil & Transformation à l'ère de l'IA",
  ecole: "Institut Mines-Télécom Business School — IMT-BS",
  formation: "Programme Grande École · Cycle Master · Master 1 (M1)",
  majeure: "Management des écosystèmes à l'ère de l'IA",
  localisation: "Vitry-sur-Seine, 94400, France",
  telephone: "+33 6 68 34 29 08",
  rythme: "3 semaines en entreprise / 1 semaine de cours",
  disponibilite: "Prise de poste dès le 3 septembre",
  mobilite: "Île-de-France · La Rochelle",
  email: "contact@andrewpicornell.fr",
  linkedin: "https://www.linkedin.com/in/andrewpicornell/",
  siteUrl: "https://andrewpicornell.fr",
  github: "",
  cvUrl: "/cv/cv-general.pdf",
  valeur:
    "Je souhaite contribuer à la transformation des organisations en mobilisant mon expérience du management opérationnel, ma compréhension des besoins métier et mon intérêt pour l'intelligence artificielle.",
  sousTitre:
    "Étudiant à IMT-BS en Management des écosystèmes à l'ère de l'IA, je recherche une alternance dans le conseil, la transformation digitale, l'innovation ou la gestion de projets liés à l'intelligence artificielle.",
};

export const apropos = {
  intro:
    "Étudiant à IMT-BS en Management des écosystèmes à l'ère de l'IA, je m'intéresse aux transformations provoquées par l'intelligence artificielle dans les entreprises et leurs écosystèmes. Mon objectif est de contribuer à des projets combinant analyse stratégique, compréhension des besoins métier, innovation et conduite du changement.",
  paragraphes: [
    "Mon parcours s'est construit en école de commerce : un BTS Management Commercial Opérationnel (mention Bien), un cycle pré-master à l'EDC Paris avec un échange universitaire à Taïwan, puis le Programme Grande École d'IMT-BS, où je me spécialise dans le management des écosystèmes à l'ère de l'IA.",
    "En parallèle, près de trois ans en management opérationnel (Shift Manager chez McDonald's, Assistant Manager chez Kankyz) m'ont appris à coordonner une équipe, piloter la performance et soigner la relation client dans des environnements exigeants.",
    "Je m'intéresse aux nouvelles technologies pour ce qu'elles changent : les métiers, les processus et les modèles de décision. J'ai une pratique avancée des IA génératives et une réelle curiosité pour la transformation digitale des organisations.",
    "Je cherche à faire le lien entre les équipes métier et les équipes techniques, à traduire un besoin en cas d'usage concret, et à développer en alternance ma pratique du conseil : diagnostic, cadrage, recommandation et conduite du changement.",
  ],
};

export const expertises = [
  { titre: "Analyse des besoins & problématiques métier", desc: "Écouter, structurer et clarifier un besoin pour le rendre actionnable." },
  { titre: "Coordination & notions de gestion de projet", desc: "Cadrer, organiser et coordonner des tâches et des acteurs autour d'objectifs communs." },
  { titre: "Sensibilisation aux enjeux de transformation digitale", desc: "Comprendre comment le digital transforme les organisations et leurs processus." },
  { titre: "Identification exploratoire de cas d'usage IA", desc: "Explorer où l'IA pourrait créer de la valeur métier, avec curiosité et esprit critique." },
  { titre: "Innovation & nouveaux modèles économiques", desc: "M'intéresser aux nouvelles sources de valeur et aux modèles émergents." },
  { titre: "Intérêt pour le Product Management & l'expérience client", desc: "M'intéresser à la conception de produits et à l'expérience utilisateur." },
];

export const vision = {
  intro:
    "Ma manière d'aborder une mission : partir du contexte de l'organisation, comprendre son écosystème, puis construire une recommandation réaliste et responsable.",
  etapes: [
    { titre: "Comprendre le contexte", desc: "Cerner les objectifs, les contraintes et les enjeux de l'organisation." },
    { titre: "Cartographier l'écosystème", desc: "Identifier les acteurs, leurs rôles et leurs interactions." },
    { titre: "Analyser besoins & données", desc: "Étudier les usages réels, les processus et les données disponibles." },
    { titre: "Évaluer les opportunités", desc: "Mesurer le potentiel offert par le digital et l'IA, sans surpromesse." },
    { titre: "Recommander", desc: "Proposer une solution réaliste, priorisée et responsable." },
    { titre: "Accompagner l'adoption", desc: "Soutenir la mise en œuvre et l'appropriation par les équipes." },
  ],
};

export const experiences = [
  {
    organisation: "Kankyz — Issy-les-Moulineaux",
    poste: "Assistant Manager",
    dates: "03/2026 – 04/2026",
    contexte: "Appui au pilotage des opérations et de l'expérience client dans un environnement de service exigeant.",
    missions: [
      "Supervision des opérations quotidiennes pour assurer la fluidité du service et le respect des standards de qualité.",
      "Gestion des commandes, des approvisionnements, des stocks et des inventaires afin de garantir la continuité de l'activité.",
      "Amélioration continue des processus opérationnels et gestion proactive des demandes clients.",
    ],
    competences: ["Management opérationnel", "Gestion des stocks", "Relation client", "Amélioration des processus"],
    resultats: "Contribution au bon déroulement du service et à la qualité de l'expérience client au quotidien.",
    type: "Expérience professionnelle",
  },
  {
    organisation: "McDonald's — Paris",
    poste: "Shift Manager",
    dates: "10/2022 – 12/2024 · 11/2025 – 12/2025",
    contexte: "Encadrement d'équipe et pilotage opérationnel d'un point de vente à fort volume d'activité.",
    missions: [
      "Coordination des opérations quotidiennes pour atteindre les objectifs de performance, de qualité et de satisfaction client.",
      "Animation et accompagnement d'une équipe, en favorisant la collaboration et la montée en compétences.",
      "Optimisation de l'organisation et de la répartition des tâches pour améliorer l'efficacité et la productivité.",
      "Résolution proactive des problématiques et respect des standards de l'enseigne.",
    ],
    competences: ["Coordination d'équipe", "Pilotage de la performance", "Organisation", "KPI & qualité"],
    resultats: "Contribution à la performance d'un point de vente à fort volume et au respect des standards de l'enseigne.",
    type: "Expérience professionnelle",
  },
];

export const cvList = [
  { slug: "consultant", axe: "Transformation & Innovation par l'IA", desc: "Imaginer des transformations utiles, responsables et adaptées aux réalités de l'organisation.", skills: ["Cadrage stratégique", "Innovation & IA", "Conseil & recommandations", "Conduite de transformation"], recommended: true, badge: "Cœur de profil", file: "/cv/cv-consultant-tech-ia.pdf", download: "CV_Andrew_Picornell_Consultant_Tech_IA_Innovation_Alternance2026.pdf" },
  { slug: "chef-projet", axe: "Projets digitaux & Conduite du changement", desc: "Coordonner les acteurs, structurer les étapes et accompagner la mise en œuvre.", skills: ["Pilotage de projet", "Coordination des acteurs", "Conduite du changement", "Déploiement d'outils"], file: "/cv/cv-chef-de-projet-tech-ia.pdf", download: "CV_Andrew_Picornell_Chef_de_Projet_Tech_IA_Alternance2026.pdf" },
  { slug: "business-analyst", axe: "Analyse métier & Solutions numériques", desc: "Comprendre les besoins, analyser les processus et contribuer au cadrage des solutions.", skills: ["Analyse des besoins", "Cadrage fonctionnel", "Modélisation des processus", "Data & solutions"], file: "/cv/cv-business-analyst.pdf", download: "CV_Andrew_Picornell_Business_Analyst_Alternance2026.pdf" },
  { slug: "business-dev", axe: "Croissance & Développement Tech", desc: "Identifier des opportunités, comprendre les besoins clients et valoriser des solutions technologiques.", skills: ["Développement commercial", "Compréhension client", "Avant-vente tech", "Création de valeur"], file: "/cv/cv-business-dev-tech-ia.pdf", download: "CV_Andrew_Picornell_Business_Developer_Tech_IA_Alternance2026.pdf" },
  { slug: "chef-produit", axe: "Produit digital & Expérience utilisateur", desc: "Contribuer à des produits et services numériques centrés sur les usages et la création de valeur.", skills: ["Vision produit", "Expérience utilisateur (UX)", "Priorisation & roadmap", "Orientation usages"], file: "/cv/cv-chef-de-produit.pdf", download: "CV_Andrew_Picornell_Chef_de_Produit_Alternance2026.pdf" },
];

export const projets = [
  {
    titre: "Impact de l'IA sur un secteur d'activité",
    tags: ["Veille", "Analyse sectorielle", "Prospective"],
    problematique: "Comprendre comment l'IA reconfigure un secteur : usages, acteurs et chaîne de valeur.",
    diagnostic: "Cartographier les cas d'usage émergents, les acteurs clés et les tensions du secteur.",
    recommandation: "Formuler des pistes d'adaptation et des scénarios d'évolution réalistes.",
    impact: "Livrable type : note de synthèse et recommandations pour éclairer une décision.",
    outils: ["Recherche", "PowerPoint", "Outils d'IA générative"],
  },
  {
    titre: "Analyse d'un écosystème d'entreprise",
    tags: ["Écosystème", "Parties prenantes", "Cartographie"],
    problematique: "Clarifier quels acteurs et interactions structurent un écosystème.",
    diagnostic: "Cartographier les parties prenantes, leurs rôles et les flux de valeur.",
    recommandation: "Identifier les leviers de coordination et les opportunités.",
    impact: "Cartographie commentée et plan d'action.",
    outils: ["Notion", "Miro", "Excel"],
  },
  {
    titre: "Recommandation de transformation digitale",
    tags: ["Transformation", "Processus", "Roadmap"],
    problematique: "Repérer un processus métier à digitaliser pour gagner en efficacité.",
    diagnostic: "Analyser le processus existant et ses points de friction.",
    recommandation: "Proposer une trajectoire de transformation priorisée et réaliste.",
    impact: "Feuille de route et quick wins identifiés.",
    outils: ["Excel", "PowerPoint", "Power BI"],
  },
  {
    titre: "Cas d'usage d'IA générative",
    tags: ["IA générative", "Cas d'usage", "Cadrage"],
    problematique: "Identifier un besoin métier que l'IA générative peut adresser.",
    diagnostic: "Qualifier le besoin, les données mobilisables et les risques.",
    recommandation: "Cadrer un cas d'usage avec ses garde-fous et sa gouvernance.",
    impact: "Note de cadrage et démonstrateur simple.",
    outils: ["Outils d'IA générative", "Notion"],
  },
  {
    titre: "Tableau de bord d'aide à la décision",
    tags: ["Data", "Dataviz", "Décision"],
    problematique: "Définir les indicateurs qui éclairent réellement une décision.",
    diagnostic: "Sélectionner les indicateurs pertinents et leurs sources de données.",
    recommandation: "Structurer un tableau de bord clair, orienté décision.",
    impact: "Maquette de tableau de bord.",
    outils: ["Power BI", "Excel"],
  },
  {
    titre: "Stratégie d'adoption responsable de l'IA",
    tags: ["Gouvernance", "Éthique", "Conduite du changement"],
    problematique: "Déployer l'IA de façon responsable et réellement adoptée.",
    diagnostic: "Analyser les enjeux d'éthique, de conformité et d'acceptabilité.",
    recommandation: "Proposer un cadre de gouvernance et un plan d'accompagnement.",
    impact: "Charte et plan d'adoption.",
    outils: ["PowerPoint", "Notion"],
  },
];

export const competences = {
  "Compétences opérationnelles & métier": ["Management opérationnel", "Coordination et animation d'équipe", "Organisation et planification", "Relation client", "Analyse des besoins clients", "Suivi des KPI et de la performance", "Analyse et amélioration des processus", "Marketing opérationnel", "Négociation commerciale et sourcing"],
  "Outils & digital": ["Pack Office", "Développement web — bases", "Utilisation des outils d'IA générative", "Coordination opérationnelle & notions de gestion de projet", "Sensibilisation aux enjeux de transformation digitale"],
  "Compétences relationnelles": ["Adaptabilité", "Résolution de problèmes", "Esprit d'initiative", "Travail en équipe", "Leadership", "Capacité de synthèse"],
  "Langues": ["Français — langue maternelle", "Anglais — B2", "Chinois (Mandarin) — A1"],
};

export const sujetsApprofondir = {
  titre: "Sujets que je souhaite approfondir",
  intro: "Des domaines que je souhaite explorer et mettre en pratique au cours de mon alternance et de ma formation.",
  items: [
    "Gouvernance et éthique de l'IA",
    "Conduite du changement",
    "Data visualisation",
    "Création de tableaux de bord",
    "Veille stratégique et technologique",
    "Management des écosystèmes",
    "Stratégie IA",
    "Business Analysis",
    "Conception de roadmaps de transformation",
  ],
};

export const alternance = {
  postes: [
    "Assistant Business Developer Tech & IA",
    "Assistant Chef de Produit / Product",
    "Assistant Chef de Projet Transformation Digitale & IA",
    "Consultant Junior Transformation, Innovation & IA",
  ],
  missions: [
    "Participer à des diagnostics stratégiques",
    "Identifier des opportunités liées à l'IA",
    "Analyser des processus métier",
    "Réaliser des études de marché et des benchmarks",
    "Préparer des recommandations",
    "Construire des présentations pour les décideurs",
    "Contribuer au pilotage de projets de transformation",
    "Accompagner l'adoption de nouveaux outils",
    "Mesurer les résultats d'une initiative",
  ],
  secteurs: ["Conseil & stratégie", "Transformation digitale", "Innovation", "Tech & IA", "Product Management"],
  apporter: "Un profil business, structuré et curieux, avec une vraie expérience du management opérationnel et de la relation client, capable de faire le lien entre les métiers et la technologie et de restituer clairement des analyses.",
  apprendre: "La pratique concrète du conseil : cadrage, diagnostic, recommandation, pilotage de projet et conduite du changement au sein de missions réelles.",
  cta: "Vous recherchez un profil capable de faire le lien entre management, métiers et intelligence artificielle ? Échangeons.",
};

export const formation = {
  etablissement: "Institut Mines-Télécom Business School — IMT-BS",
  programme: "Programme Grande École · Cycle Master (M1)",
  majeure: "Management des écosystèmes à l'ère de l'IA",
  parcours: [
    {
      etablissement: "Institut Mines-Télécom Business School (IMT-BS)",
      diplome: "Programme Grande École · Cycle Master (M1)",
      dates: "2026 – 2028 (prévu)",
      lieu: "Évry-Courcouronnes",
      current: true,
      details: [
        "Majeure : Management des écosystèmes à l'ère de l'IA",
        "Accréditations AACSB, AMBA, CGE, CEFDG — diplôme conférant le grade de Master",
        "Formation en alternance (contrat d'apprentissage)",
      ],
    },
    {
      etablissement: "EDC Paris Business School",
      diplome: "Programme Grande École · Cycle Pré-Master",
      dates: "2024 – 2025",
      lieu: "Puteaux",
      details: [
        "Échange universitaire à National Central University (Taïwan) — parcours en anglais, GPA 4,07 / A",
        "Digital Transformation, Marketing, Entrepreneurship, Managerial Finance, Cross-Cultural Management",
      ],
    },
    {
      etablissement: "École Sup'Paris — INSEEC",
      diplome: "BTS Management Commercial Opérationnel",
      dates: "2022 – 2024",
      lieu: "Paris",
      details: ["Mention Bien · 120 crédits ECTS", "Formation en alternance (contrat d'apprentissage)"],
    },
  ],
  langues: [
    { langue: "Français", niveau: "Langue maternelle" },
    { langue: "Anglais", niveau: "B2" },
    { langue: "Chinois (Mandarin)", niveau: "A1" },
  ],
};

export const navLinks = [
  { label: "Présentation", href: "accueil" },
  { label: "Profil", href: "profil" },
  { label: "Compétences", href: "competences" },
  { label: "Expériences", href: "experiences" },
  { label: "Formation", href: "parcours" },
  { label: "Contact", href: "contact" },
];
